import { levelTable, unlockTeamSlots } from '../data/index.js';
import type { GameEvent } from '../events.js';
import type { BotUser } from '../state.js';
import { teamPower } from '../formulas/power.js';

/**
 * `rpg/levelup.ts#levelupUser` with the master quirk (parity K-1): the XP
 * threshold is read once, before the loop, so a multi-level jump re-uses it.
 */
export function applyLevelUps(save: BotUser, events: GameEvent[]): void {
  const lvl = save.level.level;
  const entry = lvl < levelTable.length - 1 ? levelTable[lvl] : levelTable[levelTable.length - 1];
  if (!entry || entry.xp <= 0) return;
  const from = lvl;
  while (save.level.xp >= entry.xp) {
    save.level.xp -= entry.xp;
    save.level.level += 1;
    // `levelupUser` re-stores the team power on every level.
    save.attack = teamPower(save);
  }
  if (save.level.level > from) events.push({ type: 'levelUp', from, to: save.level.level });
}

/** XP needed for the next level at `level` (same entry levelupUser reads). */
export function xpForNextLevel(level: number): number {
  const entry = level < levelTable.length - 1 ? levelTable[level] : levelTable[levelTable.length - 1];
  return entry?.xp ?? 0;
}

/** `rpg/team.ts#getUnlockedTeamSlots`. */
export function unlockedTeamSlots(level: number): number {
  const next = unlockTeamSlots.find((u) => u > level);
  return next !== undefined ? unlockTeamSlots.indexOf(next) : unlockTeamSlots.length;
}

/** Level that unlocks the next slot, or null when all are open. */
export function nextSlotUnlockLevel(level: number): number | null {
  return unlockTeamSlots.find((u) => u > level) ?? null;
}
